import { api, queryBuilder } from "services";


export function useCheckList() {
  const getCheckListAvulsos = async (payload: any) => {
    const queryString = queryBuilder(payload);
    
    const { data } = await api.get(`/scheduling-avulsos?${queryString}`);
    return data;
  };
  const getCheckListAvulsosReport = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await api.get(`/scheduling-avulsos?${queryString}`);
    return data;
  };
  

  const getCheckListLinks= async (payload: any) => {
    const { data } = await api.post(`/checklist-get-files`, {...payload});
    return data;
  };

  return {
  getCheckListAvulsos,
  getCheckListAvulsosReport,
	getCheckListLinks
  };
}
